import React from "react";
import MergeLinkCardBase, { FooterProps } from "../shared/MergeLinkCardBase";
import CardHeader from "../shared/CardHeader";
import useAgentHandlerLinkModalContext from "../context/useAgentHandlerLinkModalContext";
import ConnectorSetupStepFormHeader from "../screens/connector-setup/ConnectorSetupStepFormHeader";
import { Connector } from "../../config/types";
import VerticalGradientSVG from "../../components/animation/VerticalGradientSVG";
import { Text } from "@merge-api/merge-javascript-shared";
import clsx from "clsx";

type Props = {
  connector?: Connector;
  onExit?: () => void;
  bottomAction?: React.ReactNode;
  centralIcon: React.ReactNode;
  text?: string;
  subText?: string;
  footerProps?: FooterProps;
  isSuccessScreen?: boolean;
  isBlockingValidationError?: boolean;
};

const InterstitialScreen = ({
  connector,
  onExit,
  bottomAction,
  centralIcon,
  text,
  subText,
  footerProps,
  isSuccessScreen,
  isBlockingValidationError,
}: Props) => {
  const showGradient = isSuccessScreen;
  const {
    allowNavigateToPreviousEntryInHistory,
    navigateToPreviousEntryInHistory,
  } = useAgentHandlerLinkModalContext();

  return (
    <MergeLinkCardBase {...footerProps}>
      <CardHeader
        onExit={() => {
          onExit
            ? onExit()
            : window.parent.postMessage({ messageType: "CLOSE_LINKING_FLOW" }, "*")
        }}
        onBack={
          allowNavigateToPreviousEntryInHistory ? navigateToPreviousEntryInHistory : undefined
        }
      />
      <div className="flex-1 flex flex-col items-center justify-start">
        <div className="flex justify-start overflow-hidden px-2">
          {connector ? (
            <ConnectorSetupStepFormHeader connector={connector} />
          ) : (
            <div className="flex flex-shrink-0 my-9">
              <div className="flex h-[32px]" />
            </div>
          )}
        </div>
        <VerticalGradientSVG
          className={clsx(
            "mb-6 h-[140px] [@media(max-height:600px)]:h-[80px]",
            showGradient ? "animate-pulse" : "invisible"
          )}
        />

        <div className="flex flex-col items-center justify-start">
          <div className="flex justify-center">{centralIcon}</div>
          <div className="w-full flex flex-grow flex-col items-center justify-start mt-6 text-center px-5 pb-[64px] [@media(max-height:600px)]:pb-[32px]">
            <Text variant="h4" className="mb-2">
              {text}
            </Text>
            <Text variant={isBlockingValidationError ? "md" : "lg"}>{subText}</Text>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center w-full p-5">{bottomAction}</div>
    </MergeLinkCardBase>
  );
};

export default InterstitialScreen;
